import _regeneratorRuntime from "/root/code/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { useEffect, useState } from "react";
import useSWR, { mutate } from "swr";
import { produce } from "immer";
import { useEventBus, legacyEventBus } from "@catchoftheday/state";
import { fetcher } from "../../api/index";
import { localStorage, updateWishlistStateOptimistically, createToast, updateToast } from "../../utilities/index";
import { HEADER_META_DATA_API } from "../../consts/index";

var createToastHandler = function createToastHandler(toastEvent) {
  createToast(toastEvent);
};

var updateToastHandler = function updateToastHandler(toastEvent) {
  updateToast(toastEvent);
};

export var useHeaderMetaData = function useHeaderMetaData(headerConfiguration) {
  var _headerConfiguration$, _headerConfiguration$2, _headerConfiguration$3, _headerConfiguration$4, _headerConfiguration$5, _headerConfiguration$6, _headerConfiguration$7, _JSON$parse;

  var _useState = useState(false),
      firstRequestComplete = _useState[0],
      setFirstRequestComplete = _useState[1];

  var initialHeaderMetaData = headerConfiguration ? {
    displayName: "",
    loggedIn: headerConfiguration.primaryHeader.myAccount.loggedIn,
    flybuysLinked: headerConfiguration.primaryHeader.flybuys.linked,
    cartItemCount: Number(headerConfiguration.primaryHeader.cart.itemCount),
    wishlistItemCount: Number(headerConfiguration.primaryHeader.wishlist.itemCount),
    messageCount: headerConfiguration.primaryHeader.myAccount.messageCount,
    megaMenuEnabled: (_headerConfiguration$ = headerConfiguration.megaMenu) === null || _headerConfiguration$ === void 0 ? void 0 : _headerConfiguration$.enabled,
    navData: (_headerConfiguration$2 = headerConfiguration.megaMenu) === null || _headerConfiguration$2 === void 0 ? void 0 : (_headerConfiguration$3 = _headerConfiguration$2.navData) === null || _headerConfiguration$3 === void 0 ? void 0 : _headerConfiguration$3.shops,
    essentialsMenu: (_headerConfiguration$4 = headerConfiguration.megaMenu) === null || _headerConfiguration$4 === void 0 ? void 0 : (_headerConfiguration$5 = _headerConfiguration$4.navData) === null || _headerConfiguration$5 === void 0 ? void 0 : _headerConfiguration$5.catchEssentialsMenu,
    accountMenu: (_headerConfiguration$6 = headerConfiguration.megaMenu) === null || _headerConfiguration$6 === void 0 ? void 0 : (_headerConfiguration$7 = _headerConfiguration$6.navData) === null || _headerConfiguration$7 === void 0 ? void 0 : _headerConfiguration$7.accountMenu,
    couponNotificationEnabled: false,
    isOnePassBeta: false
  } : undefined;
  useEventBus({
    type: "@cart-app/ADD_TO_CART"
  }, function () {
    mutate(HEADER_META_DATA_API, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(currentData) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", produce(currentData, function (newState) {
                  if (newState !== null && newState !== void 0 && newState.data) {
                    newState.data.cartItemCount = Number(newState.data.cartItemCount) + 1;
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }, []);
  useEventBus({
    type: "@cart-app/REMOVE_ITEM_FROM_CART"
  }, function () {
    mutate(HEADER_META_DATA_API, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(currentData) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", produce(currentData, function (newState) {
                  if (newState !== null && newState !== void 0 && newState.data) {
                    newState.data.cartItemCount = Number(newState.data.cartItemCount) - 1;
                  }
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  }, []);
  useEventBus({
    type: "@cart-app/ADD_TO_WISHLIST"
  }, function () {
    mutate(HEADER_META_DATA_API, /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(currentData) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", produce(currentData, function (newState) {
                  if (newState !== null && newState !== void 0 && newState.data) {
                    newState.data.wishlistItemCount = Number(newState.data.wishlistItemCount) + 1;
                  }
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
  }, []);
  useEventBus({
    type: "@cart-app/UPDATE_PRODUCT_QUANTITY"
  }, function (_ref4) {
    var payload = _ref4.payload;
    mutate(HEADER_META_DATA_API, /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(currentData) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", produce(currentData, function (newState) {
                  if (newState !== null && newState !== void 0 && newState.data && payload !== null && payload !== void 0 && payload.cartItemCount) {
                    newState.data.cartItemCount = Number(payload === null || payload === void 0 ? void 0 : payload.cartItemCount);
                  }
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }());
  }, []);
  useEffect(function () {
    legacyEventBus === null || legacyEventBus === void 0 ? void 0 : legacyEventBus.on("GET_CART", function (_ref6) {
      var eventData = _ref6.data;
      mutate(HEADER_META_DATA_API, /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(currentData) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", produce(currentData, function (newState) {
                    if (newState !== null && newState !== void 0 && newState.data) {
                      newState.data.cartItemCount = eventData.quantity;
                    }
                  }));

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x5) {
          return _ref7.apply(this, arguments);
        };
      }());
    });
    legacyEventBus === null || legacyEventBus === void 0 ? void 0 : legacyEventBus.on("UPDATE_WISHLIST", function () {
      updateWishlistStateOptimistically();
    });
  }, []);
  useEffect(function () {
    legacyEventBus === null || legacyEventBus === void 0 ? void 0 : legacyEventBus.on("CREATE_TOAST", createToastHandler);
    return function () {
      legacyEventBus === null || legacyEventBus === void 0 ? void 0 : legacyEventBus.detach("CREATE_TOAST", createToastHandler);
    };
  }, []);
  useEffect(function () {
    legacyEventBus === null || legacyEventBus === void 0 ? void 0 : legacyEventBus.on("UPDATE_TOAST", updateToastHandler);
    return function () {
      legacyEventBus === null || legacyEventBus === void 0 ? void 0 : legacyEventBus.detach("UPDATE_TOAST", updateToastHandler);
    };
  }, []);

  var _useSWR = useSWR(HEADER_META_DATA_API, fetcher, {
    onError: function onError() {
      setFirstRequestComplete(true);
    },
    onErrorRetry: function onErrorRetry() {
      setFirstRequestComplete(true);
    },
    onSuccess: function onSuccess(data, key) {
      setFirstRequestComplete(true);
      localStorage.setItem(key, JSON.stringify({
        data: data === null || data === void 0 ? void 0 : data.data
      }));
    }
  }),
      response = _useSWR.data,
      isValidating = _useSWR.isValidating;
  /** Use localStorage to cache user information */


  var metaData = (response === null || response === void 0 ? void 0 : response.data) || initialHeaderMetaData || ((_JSON$parse = JSON.parse(localStorage.getItem(HEADER_META_DATA_API) || "{}")) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.data) || undefined;
  return {
    metaData: metaData,
    initialHeaderMetaData: initialHeaderMetaData,
    isLoading: !metaData && isValidating || !firstRequestComplete
  };
};